import { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { rewardTypeFilter } from "@/utils/filter/rewardTypeFilter";
import { getWayFilter } from "@/pages/coupon/constant/coupon-filter";
import { dateFormatter } from "project-config/utils/date-formatter";
import { getTranslateNsT } from "@/utils/getTranslateNsT";

export function useColumns() {
  const { t } = useTranslation("center");

  const columns: ColumnsType<any> = [
    { dataIndex: "payRecordId", title: t("record_header_id") },
    { dataIndex: "couponNo", title: t("record_header_coupon_id") },
    {
      dataIndex: "type",
      title: t("record_header_coupon_type"),
      render: (row) => rewardTypeFilter(row),
    },
    {
      dataIndex: "amount",
      title: t("coupon_header_amount"),
      render: (row) => Number(row).toFixed(3),
    },
    {
      dataIndex: "couponUpdate",
      title: t("record_header_coupon_balance"),
      render: (row) => Number(row).toFixed(3),
    },
    {
      dataIndex: "payMethod",
      title: t("record_header_claim_method"),
      render: (row) => getTranslateNsT("coupon")(getWayFilter(row)),
    },
    {
      dataIndex: "inOutCome",
      title: t("record_header_type"),
      render: (row: number) =>
        ({ 1: t("income_type"), 2: t("outcome_type") }[row]),
    },
    {
      dataIndex: "expireDate",
      title: t("record_header_expire_date"),
      render: (row) => dateFormatter(row),
    },
    {
      dataIndex: "createDate",
      title: t("coupon_header_usetime"),
      render: (row) => dateFormatter(row),
    },
    {
      dataIndex: "relatedNo",
      title: t("coupon_header_source"),
      render: (row, r) => (row ? `${r.destName}:${row}` : ""),
    },
  ];

  return { columns };
}
